import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import moment from 'moment';

import { ITepEntryPass } from 'types/tep';
import { Tooltip } from 'components/atoms/tooltip';
import { close, edit2, remove, save } from 'assets/icons';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { issueModalActionsSelector } from 'core/redux/selectors/tep';
import { actions as leasesActions } from 'core/redux/api/veta/tep/leases';

import styles from './styles.module.css';

interface IActionsProps {
  entryPass: ITepEntryPass;
}

export const Actions: FC<IActionsProps> = ({ entryPass }) => {
  const dispatch = useDispatch();

  const { id, leases } = useSelector(issueModalActionsSelector);

  const { handleSubmit } = useFormContext<{ device: ITepEntryPass }>();

  const isSelected = entryPass?.id === id;

  const setSelectedLease = (id: number | null) => dispatch(leasesActions.edit({ id }));

  const onSubmit = () => {
    if (id) {
      handleSubmit(({ device }) => {
        const { email, plateNumber, startOn, endOn } = device.lease;

        const data = {
          email,
          plateNumber,
          startOn: moment(startOn).format('YYYY-MM-DD'),
          endOn: moment(endOn).format('YYYY-MM-DD'),
        };

        dispatch(leasesActions.update.request({ id, data }));
      })();
    }
  };

  const onEdit = () => {
    setSelectedLease(entryPass.id);
  };

  const onSave = () => {
    onSubmit();
  };

  const onRemove = () => {
    const updatedLeases = leases.filter(({ id }) => id !== entryPass.id);

    updatedLeases.length ? dispatch(leasesActions.select({ leases: updatedLeases })) : dispatch(leasesActions.close());
  };

  const onCancel = () => {
    setSelectedLease(null);
  };

  return (
    <div className={styles.actions}>
      {isSelected ? (
        <>
          <Tooltip text="save">
            <SvgWrapper width={24} height={24} details={save} onClick={onSave} />
          </Tooltip>
          <Tooltip text="close without saving">
            <SvgWrapper width={24} height={24} details={close} onClick={onCancel} />
          </Tooltip>
        </>
      ) : (
        <>
          <Tooltip text="edit">
            <SvgWrapper width={24} height={24} details={edit2} onClick={onEdit} />
          </Tooltip>
          <Tooltip text="remove">
            <SvgWrapper width={24} height={24} details={remove} onClick={onRemove} />
          </Tooltip>
        </>
      )}
    </div>
  );
};
